export const COMPONENTS = {
  container: 'Container',
  content_container: 'Content Container',
};
